<template>
    <div class="helpDetail flex align-cen" id="helpDetail"
    v-loading="loading"
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="努力加载中，您先喝杯茶～～"
    >
        <div class="left">
           <div class="left-tit flex align-cen">
             <el-input
            placeholder="请输入关键词"
            v-model="serch"
            @keyup.enter.native="search"
            @input="resetSe"
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
         </el-input>
       
           </div>
         <div class="helpDetail-navbar">
            <div class="chapter-list">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list.chapterList" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                      {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit"
                               :class="{current: detailid === childItem.id}"
                               @click="openDetail(childItem.id,index,childIndex)"
                               >
                                 {{childItem.name}}
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
         </div>
        </div>
        </div>
        <div class="right">
            <div class="right-tit flex align-cen">
                {{list.title}}
                 <div class="mft share" @click="opneCanvas">
                    <span class="icon-al-share1" style="font-size:20px;padding-right:30px;cursor: pointer;"></span>
                </div>
                <i class="icon-al-menu" @click="toggleMenu"></i>
            </div>
            <div v-html="content" v-if="content" class="nr" id="nr"></div>
         <div class="right-bot flex align-cen" v-if="content">
                <div @click="openDetail(prevId,publicIndex,prevIndex)">
                    <i class="icon-al-angle-left" ></i>
                    {{prev}}
                    </div>
                <div class="mft" @click="openDetail(nextId,publicIndex,nextIndex)">
                    {{netx}}
                 <i class="icon-al-angle-right"></i>
                    </div>
            </div>
            <div v-else class="flex align-cen emtey">
                <div>
                    <i class="icon-al-cry-fill"></i>
                    <p>{{activeName}}暂无内容，请先去编辑</p>
                    <div class="btn" @click="reback">返回帮助中心</div>
                </div>
            </div>
        </div>
        <div class="rMenu" :class="{active:isShow}">
				   <div class="rMenu-left">
            <el-input
            placeholder="请输入关键词"
            v-model="serch"
            @keyup.enter.native="search"
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
         <div class="helpDetail-navbar">
            <div class="chapter-list">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list.chapterList" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                      {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit"
                               :class="{current: detailid === childItem.id}"
                               @click="openDetail(childItem.id,index,childIndex)"
                               >
                                 {{childItem.name}}
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
         </div>
        </div>
        </div>
			</div>
             <el-dialog
            title="分享海报"
            :visible.sync="centerDialogVisible"
            width="350px"
            :append-to-body="true"
            center>
            <div class="dia-can">
                 <vue-canvas-poster :widthPixels="292" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile('pster',posterImg)">保存</div>
            <div class="mobil-dia-btn">
                <div class="mobil-share-btn  flex align-cen justify-content-cen">
                    <div class="save" @click="$util.downloadFile('pster',posterImg)" v-if="!isweixin"> 保存</div>
                <!-- <div class="fride" v-if="isweixin">分享给朋友</div> -->
                <div class="frideline" v-if="isweixin" @click="$util.downloadFile('pster',posterImg)">保存分享朋友圈</div>
                </div>
            </div>
            </el-dialog>
    </div>
</template>
<script>
import { frontdetail } from "@/api/enterprise/index" // 帮助详情
import {  chapterDetail } from "@/api/enterprise/index"  //章节详情
import "../../assets/styles/font.css";
    export default {
        name: "enhelpdetail",
        components: {
        },
        data(){
            return {
            loading:false,
            centerDialogVisible:false,
            list:[],
            serch:'',
            activeNames:[],
            detailid:'',
            content:'',
            next:'',
            prev:'',
            publicIndex:'',
            nextIndex:'',
            nextId:'',
            prevId:'',
            prevIndex:'',
            publicLebfth:'',
            user_info:'',
            autodetai:true,
            isShow:false,
            activeName:'',
            isweixin:false,
                        posterImg: "",
              painting: {
                    width: '292px',
                    height: '480px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: require('../../assets/images/banner1.jpg'),
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '100%',
                                height: '200px'
                            },
                        },
                         {
                            type: 'image',
                            url: require('../../assets/images/user.png'),
                            css: {
                                top: '220px',
                                left: '20px',
                                width: '60px',
                                height: '60px'
                            },
                        },
                        {
                            type:'text',
                            text: '想要分享给你',
                            css: {
                                top:'240px',
                                left:'90px',
                                 width: "100%",
                            textAlign: "left",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'290px',
                                left:'40px',
                                 width: "210px",
                            textAlign: "left",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '340px',
                            left: '96px',
                            color: '#000',
                            width: '100px',
                            height: '100px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：南京睿首智能技术研究院',
                            css: {
                                bottom:'10px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
                },
            }
        },
        created() {
         let token1 = localStorage.getItem('token1')
         let that = this
            if(token1){
         this.user_info =  JSON.parse(localStorage.getItem('userinfo1'));
         }
                //    异步同步执行
            this.getInfo().then(function(){
            if(that.autodetai) that.openDetail(that.detailid,0,0)
            that.handleChangeImg()
            })
        },
        mounted() {},
        computed: {
        },

        watch: {},
        methods: {
            // 
            resetSe(){
                if(!this.serch ){
                    this.search()
                }
            },
                // 手动修改views
        handleChangeImg(){
             this.painting.views[3].text = this.list.title + '文档。'
             this.painting.views[4].content = this.$config.prUrl + '#'+ this.$route.fullPath
        },
              //打开海报
        opneCanvas(){
            this.centerDialogVisible = true
              var broser = window.navigator.userAgent.toLowerCase();
            //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
            if (broser.match(/MicroMessenger/i) == 'micromessenger') {
               this.isweixin = true
            } else {
               this.isweixin = false
            }
        },
           success(src) {
             this.posterImg = src;
            },
            fail(err) {
                console.log('fail', err)
            },
            // 搜索
            search(){
                let that = this
                 this.getInfo().then(function(){
            if(that.autodetai) that.openDetail(that.detailid,0,0)
            })
            },
            reback(){
                this.$router.push('/webenterprise/enhelpList')
            },
            // 侧边栏
            toggleMenu: function() {
				this.isShow = !this.isShow
			},
            async getInfo(){
            this.loading = true 
           await  frontdetail({
                id:this.$route.query.id,
                userId:this.user_info.id,
                name:this.serch
            },'enterprise')
            .then(res => {
                this.loading = false
                if(res.code == 0){
                     this.list = res.data
                     document.title= res.data.title
                     this.detailid = res.data.chapterList[0].children[0].id
                     this.activeName = res.data.chapterList[0].name + '-' +res.data.chapterList[0].children[0].name
                     this.autodetai = true
                      for (const key in res.data.chapterList) {
                        this.activeNames.push(res.data.chapterList[key].id)
                        }
                }else{
                    this.autodetai = false
                    if(res.msg == '帮助未设置权限给企业' || res.msg == '未查询到用户信息，请登录'){
                        this.$message.error(res.msg)
                         localStorage.removeItem('token1')
                localStorage.removeItem('userinfo1')
                                   this.$router.replace({
                                    name:'enLogin',
                                    query: {
                                        id:this.$route.query.id,
                                        redirectUrl:'enhelpdetail' 
                                    }
                       
                      })
                    }else{
                        this.$message.error(res.msg) 
                    }
                    
                }
            })
            .catch(err => {
                this.loading = false
            })
            },
                detail(){
               chapterDetail({
                id:this.detailid
              },'enterprise')
            .then(res => {
             this.content = res.data.content
                  this.$nextTick(function(){
                 const imgDomArray = document.getElementById('nr')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
            })
            .catch(err => {
            })
        },
        // 切换详情
        openDetail(id,index,childIndex){
        this.isShow = false
        this.detailid  = id
        this.publicIndex = index
        this.publicLebfth = this.list.chapterList[index].children.length-1
         this.activeName = this.list.chapterList[index].name + '-' +this.list.chapterList[index].children[childIndex].name
     if(childIndex >= this.list.chapterList[index].children.length-1){
             this.netx = "暂无小节"
        }else{
             this.netx = this.list.chapterList[index].children[childIndex+1].name
             this.nextId = this.list.chapterList[index].children[childIndex+1].id
             this.nextIndex = childIndex+1
        }
        if(childIndex == 0){
        this.prev = "暂无小节"
        }else{
           this.prev = this.list.chapterList[index].children[childIndex-1].name 
           this.prevId = this.list.chapterList[index].children[childIndex-1].id
           this.prevIndex = childIndex-1
        }

        this.detail()
        },
        }
    }
</script>
<style lang="scss" scoped>
.ql-align-center{
    text-align: center;
}
.helpDetail{
    width: 100%;
    margin: 0 auto;
    height: 100vh;
     .mobil-share-btn{
        display: none;
    }
    .left{
        width: 316px;
        height: inherit;
        background: #F7F7F7;
         position: fixed;
        left: 0;
        top: 0;
        .el-input{
            width: 90%;
            margin: 0 auto;
            display: block;
            margin-top: 20px;
        }
        .helpDetail-navbar{
           margin: 0 auto;
           padding: 0 30px;
           margin-top: 40px;
            overflow: auto;
           height: calc(100% - 100px);
           .numlist-tit{
            .tit-name{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
            }
           }
           .childrenlist-tit{
            cursor: pointer;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #989898;
            line-height: 50px;
           }
           .current{
            background: #D3ECFF;
            color: #1684FC;
            width: 100%;
           }
           .el-collapse{
            border: none;
            
           }
        }
    }
    .right{
        width: calc(100% - 316px);
        height: inherit;
        position: relative;
         position: fixed;
        left: 316px;
        .right-tit{
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 48px;
            padding: 20px 40px;
            i{
                display: none;
            }
        }
        .nr{
            width: 90%;
            margin: 0 auto;
            margin-bottom: 50px;
            border-bottom: 1px solid #ccc;
            height: calc(100% - 180px);
            overflow: auto;
        }
        .right-bot{
            position: absolute;
            width: 90%;
            left: 5%;
            bottom: 30px;
            cursor: pointer;
            color: #BDBDBD;
            line-height: 36px;
            font-size: 14px;
            i{
                font-size: 12px;
            }
        }
        .emtey{
            justify-content: center;
            text-align: center;
            padding-top: 20vh;
             color: #ccc;
            i{
                font-size: 50px;
                color: #ccc;
                
            }
            .btn{
               padding: 10px 20px;
               background: #155bd4;
               color: #fff;
               border-radius: 5px;
               margin-top: 20px;
               cursor: pointer;
            }
        }
    }
    .rMenu{
        display: none;
    }
}
@media (max-width: 640px){
    #helpDetail{margin-top: -56px;}
    .dia-btn{
        display: none;
    }
      .mobil-dia-btn{
        display: block;
        .mobil-share-btn{
            div{
                height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
            }
        }
    }
    .el-dialog{
        margin-top: 10vh !important;
    }
  .helpDetail{
    width: 100%;
    .left{
        display: none;
    }
    .right{
        left: 0;
          .right-tit{
            padding: 0;
            font-size: 16px;
            text-align: center;
            height: 50px;
            line-height: 50px;
           box-shadow: 0px 0px 10px rgba(0,0,0,.4);
           position: relative;
           display: block;
           i{
            position: absolute;
            display: block;
            right: 20px;
            top: 0px;
            display: block;
           }
            .share{
            position: absolute;
            left: 20px;
            top: 0;
        }
        }
        
        .nr{
            margin-top: 10px;
        }
        width: 100%;
    }
  }
  	.rMenu{
        display: block !important;
		width: 70vw;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		transform: translateX(-71vw);
		background: #fff;
		transition: transform 0.5s;
         box-shadow:3px 0px 5px rgba(0,0,0,.4);
      .rMenu-left{
        width: 100%;
        height: 100%;
        overflow: hidden;
                overflow: auto;
        background: #F7F7F7;
        .el-input{
            width: 90%;
            margin: 0 auto;
            display: block;
            margin-top: 20px;
        }
        .helpDetail-navbar{
           margin: 0 auto;
           padding: 0 30px;
           margin-top: 40px;
           .numlist-tit{
            .tit-name{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
            }
           }
           .childrenlist-tit{
            cursor: pointer;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #989898;
            line-height: 50px;
           }
           .current{
            background: #D3ECFF;
            color: #1684FC;
            width: 100%;
           }
           .el-collapse{
            border: none;
            
           }
        }
    }
	}
	.active{
		transform: translateX(0vw);
	}
}
::v-deep {
.ql-video{
    max-width: 100%;
}
     .mobil-dia-btn{
        display: none;
    }
    .el-collapse-item__wrap,.el-collapse-item__header{
                background: transparent;
                border: none;
            }
    .el-collapse-item__content{
        padding-bottom: 0;
    }
    @media (max-width: 640px){
    .el-dialog{
        margin-top: 10vh !important;
    }
       .mobil-dia-btn{
        display: block;
    }
}
    .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
        .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
    .el-dialog__body{
        padding: 20px 10px;
    }
}
</style>
